// Polyfill from https://github.com/ungap/random-uuid
// TODO - Remove this once our usage of Safari 15.3 and lower is low enough.
if (window && window.crypto && typeof window.crypto.randomUUID !== 'function') {
  window.crypto.randomUUID = function randomUUID() {
    return (
        // eslint-disable-next-line no-magic-numbers
      [1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g,
        // eslint-disable-next-line no-magic-numbers
      c => (c ^ window.crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  };
}

if (!Array.prototype.at) {
  require('core-js/features/array/at.js');
}

// Helper function to convert CSS4 :not() with comma-separated selectors to CSS3 compatible format
function convertNotSelector(selector) {
  // Match :not() with comma-separated selectors (CSS4 syntax)
  const notMatch = selector.match(/:not\(([^)]+)\)/);
  if (notMatch && notMatch[1].includes(',')) {
    const notContent = notMatch[1];
    const selectors = notContent.split(',').map(s => s.trim());
    // Convert :not(a, b) to :not(a):not(b)
    const convertedNot = selectors.map(s => `:not(${s})`).join('');
    return selector.replace(notMatch[0], convertedNot);
  }
  return selector;
}

// Polyfill for Element.prototype.matches with fallback for execution failures
function selectorMatches(element, selector) {
  try {
    // Try to convert CSS4 syntax to CSS3 compatible format
    const compatibleSelector = convertNotSelector(selector);
    const elements = document.querySelectorAll(compatibleSelector);
    return Array.from(elements).includes(element);
  } catch (e) {
    return false;
  }
}

if (Element && !Element.prototype.matches) {
  const vendorMatches = Element.prototype.matchesSelector
    || Element.prototype.webkitMatchesSelector
    || Element.prototype.mozMatchesSelector
    || Element.prototype.msMatchesSelector
    || Element.prototype.oMatchesSelector;

  Element.prototype.matches = function(selector) {
    if (vendorMatches) {
      try {
        return vendorMatches.call(this, selector);
      } catch (e) {
        return selectorMatches(this, selector);
      }
    } else {
      return selectorMatches(this, selector);
    }
  };
}
